export default __webpack_public_path__ + "static/hero-ai-desktop-8c4191f8b1ae9b939eebb8d144476c01.webp";